import React, { useEffect, useContext, useState } from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  ClearSearchButton,
} from "react-bootstrap-table";
import MontantVersesAuxPrestatairesTableSkeleton from "./MontantVersesAuxPrestatairesTableSkeleton";
import * as IconlyPack from "react-iconly";
import { NavLink } from "react-router-dom";
import { DataContext } from "../../store/GlobalState";
import MontantVersesAuxPrestatairesTableData from "./MontantVersesAuxPrestatairesTableData";
import { formatMontant } from "../../../utils/utils";
import { getDataByID } from "../../utils/fetchData";
// import UseEditEntrepriseForm from '../../Backend/IPM/GestionEntreprises/UseEditEntrepriseForm'
// import CRUDEntrepriseModal from './../../Modals/CRUDEntrepriseModal'

var MontantVersesAuxPrestatairesTable = ({ auth }) => {
  const [topPrestataires, setTopPrestataires] = useState([]);
  var [isPageLoading, setIsPageLoading] = useState(true);
  useEffect(() => {
    if (!auth?.user?.admin_type) {
      getDataByID(`top10montantbyipm`, auth?.user?.id, auth?.token).then(
        (response) => {
          // console.log("response", response);
          setTopPrestataires(response?.top10MontantPrestataire);
          setIsPageLoading(false);
        }
      );
    } else {
      getDataByID(`top10montantbyipm`, auth?.user?.id, auth?.token).then(
        (response) => {
          setTopPrestataires(response?.top10MontantPrestataire);
          setIsPageLoading(false);
        }
      );
    }
  }, [auth]);

  const presFormat = (cell, row) => {
    return row?.item?.prenom
      ? row?.item?.prenom + " " + row?.item?.nom
      : row?.item?.raison_sociale;
  };

  const presIDFormat = (cell, row) => {
    return row?.item?.id;
  };

  const montantFormat = (cell, row) => {
    return formatMontant(cell);
  };

  const options = {
    sizePerPage: 5,
    clearSearch: true,
    noDataText: "Aucune donnée disponible",
    expandBy: "column",
  };

  return (
    <div className="child-table-container">
      <div className="table-body-container">
        <div className="row easypm-table-row m-t-50 m-b-50">
          <div className="col-md-12 easypm-table-col">
            {isPageLoading && <MontantVersesAuxPrestatairesTableSkeleton />}
            {!isPageLoading && (
              <div className="table-container">
                <BootstrapTable
                  data={topPrestataires}
                  striped={true}
                  hover={true}
                  condensed={true}
                  multiColumnSort={2}
                  options={options}
                  pagination
                  search={false}
                  version="4"
                  bordered={false}
                >
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1F497D",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    dataField="id"
                    isKey={true}
                    hidden={false}
                    width="50"
                    dataFormat={presIDFormat}
                  >
                    N°
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1F497D",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    dataFormat={presFormat}
                    dataField="montant_adherent"
                  >
                    Prestataire
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    thStyle={{
                      fontWeight: 600,
                      fontSize: 16,
                      color: "#1F497D",
                    }}
                    tdStyle={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                    dataFormat={montantFormat}
                    dataField="montant"
                    width="200"
                    dataAlign="right"
                  >
                    Montant (F CFA)
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MontantVersesAuxPrestatairesTable;
